import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DataService } from '../../../data.service';
import { Router, NavigationEnd, ActivatedRoute, NavigationExtras } from '@angular/router';
import { SessionStorageService } from 'angular-web-storage';

declare let $;
@Component({
  selector: 'app-deposit',
  templateUrl: './deposit.component.html',
  styleUrls: ['./deposit.component.scss'],
})
export class DepositComponent implements OnInit {
  currentUrl: string | undefined;
  acc: any;
  plan: any;
  users: any;
  step: number = 1;
  profit: any;
  Id: any;
  amount: any;
  amount1: any;
  term: any;
  paymethod: any;
  ammethod: any;
  percent: any;
  netprofit: any;
  amountTopay: any;
  addressTopay: any;
  pucg: number = 0;
  show = 1;
  country: any;
  promo: any;
  display: number = 0;
  bank: any;
  tic: any;
  banks: any;
  rand: any;
  amm: any;
  money = 0;
  options: any;
  duration: any;
  spend: any;
  type: any;
  his: any;
  tra = [];
  gram: number | null = null;
  upID: any;
  upU: any;
  upi: any;
  aqui: any;
  oron: any;
  bela: any;
  siri: any;
  cip: any;

  selectedPayment: string = '';
paymentMethods: { label: string; value: string }[] = [];

  constructor(
    private server: DataService,
    public toastr: ToastrManager,
    public session: SessionStorageService,
    private route: Router,
    private activate: ActivatedRoute,
  ) {
    route.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
    if ($(".toggled")) {
      $("#tog").click();
    }
    $('.app-wrap').removeClass('sidebar-toggled');
    this.duration = 1;

    this.activate.queryParams.subscribe((res) => {
      if (res.hasOwnProperty('dep')) {
        if (res.dep == 'contract') {
          this.step = 2;
        } else {
          this.step = 1;
        }

        this.his = res.dep;
        // if ($('.sidebar-enable')[0]) {
        //   $('#tog').click();
        // }
      }
    });
  }

  ngOnInit() {

    $('meta[name=viewport]').attr(
      'content',
      'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0'
    );
    this.options = this.activate.snapshot.queryParamMap.get('option');
    // this.amount = this.activate.snapshot.queryParamMap.get('amount');

    this.pucg =  1;
    if(this.options == 'special'){
       this.gram = Number(this.activate.snapshot.queryParamMap.get('gram'));
       this.duration = this.activate.snapshot.queryParamMap.get('duration');
       this.percent = this.activate.snapshot.queryParamMap.get('per');

    }

    this.chackGram();

    this.Id = this.session.get('sessionID');
   const data = this.activate.snapshot.data?.['news'];

    if (!data) {
      console.warn('Resolver returned no data');
      return;
    }

    const msg = data?.dep?.message?.[0];

    this.acc = msg?.mainaccountbal ?? 0;
    this.country = msg?.country ?? null;
    this.users = msg?.username ?? null;

    this.promo = data?.promo?.message?.[0]?.status ?? null;
    this.upi = data?.upi?.message?.[0]?.status ?? null;

    this.display = 0;
    this.bank = 0;

    // SAFE allIn access
    // const plans = data?.allIn?.message ?? [];

    // if (plans.length) {
    //   this.aqui = plans.filter(p => p.plan === 'AQUI').length;
    //   this.oron = plans.filter(p => p.plan === 'ORON').length;
    //   this.bela = plans.filter(p => p.plan === 'BELA').length;
    //   this.siri = plans.filter(p => p.plan === 'SIRI').length;
    //   this.cip = plans.filter(p => p.plan === 'CIPs').length;
    // }

    // // SAFE history access
    // this.tra = (data?.his?.plann ?? []).filter(
    //   word => word.type === 'Invest'
    // );

     this.buildPaymentMethods();
  }


ngOnChanges() {
  this.buildPaymentMethods();
}

buildPaymentMethods() {
  const methods = [];


  if (this.country === 'India') {
    methods.push({ label: 'Bank Transfer', value: 'Bank' });

    if (this.upi == 1) {
      methods.push({ label: 'UPI', value: 'UPI' });
    }
  }

  methods.push(
    { label: 'USDT (TRC20)', value: 'USDT(TRC20)' },
    { label: 'USDT (BEP20)', value: 'USDT(BEP20)' },
    { label: 'XRP', value: 'XRP' },
    { label: 'Wallet Balance', value: 'Account' }
  );

  this.paymentMethods = methods;
}

  calculate(x: NgForm) {
    if(!this.checkEligibilty()){
      return;
    };
    this.options = this.options;
    let Deposit = parseFloat(this.amount);
    let spendFrom = x.value.spend;

   // STARTER PACK
    if (this.options == 'starter') {
      this.term = 0.625; // 15 Hours

      if (Deposit >= 39 && Deposit <= 260) {
        const roi = Deposit <= 150 ? 1.05 : 1.06;

        this.profit = Math.floor(Deposit * roi);
        this.percent = roi;
      } else {
        return this.toastr.warningToastr(
          `$${Deposit} not avalable for this plan`,
        );
      }
    }

    // PRIME BULLION PACK
    if (this.options == 'prime') {
      this.term = 1; // 24 Hours

      if (Deposit >= 325 && Deposit <= 585) {
        const roi = Deposit <= 450 ? 1.07 : 1.09;

        this.profit = Math.floor(Deposit * roi);
        this.percent = roi;
      } else {
        return this.toastr.warningToastr(
          `$${Deposit} not avalable for this plan`,
        );
      }
    }

    // ELITE VAULT PACK
    if (this.options == 'elite') {
      this.term = 4;

      if (Deposit >= 650 && Deposit <= 1300) {
        const roi = Deposit <= 900 ? 1.1 : 1.13;

        this.profit = Math.floor(Deposit * roi);
        this.percent = roi;
      } else {
        return this.toastr.warningToastr(
          `$${Deposit} not avalable for this plan`,
        );
      }
    }

    // SOVEREIGN PACK
    if (this.options == 'sovereign') {
      this.term = 10;

      if (Deposit >= 1950 && Deposit <= 6500) {
        const roi = Deposit <= 3500 ? 1.18 : 1.25;

        this.profit = Math.floor(Deposit * roi);
        this.percent = roi;
      } else {
        return this.toastr.warningToastr(
          `$${Deposit} not avalable for this plan`,
        );
      }
    }

    // AURUM RESERVE PACK
    if (this.options == 'aurum') {
      this.term = 15;

      if (Deposit >= 7800 && Deposit <= 13000) {
        const roi = Deposit <= 10000 ? 1.28 : 1.35;

        this.profit = Math.floor(Deposit * roi);
        this.percent = roi;
      } else {
        return this.toastr.warningToastr(
          `$${Deposit} not avalable for this plan`,
        );
      }
    }

    // CLASSIC PACK
    if (this.options == 'classic') {
      this.term = 30;

      if (Deposit >= 130 && Deposit <= 1300) {
        this.percent = 1.6;
        this.profit = Math.floor(Deposit * this.percent);
      } else {
        return this.toastr.warningToastr(
          `$${Deposit} not avalable for this plan`,
        );
      }
    }

    // PRESTIGE TIER
    if (this.options == 'prestige') {
      this.term = 30;

      if (Deposit >= 1950 && Deposit <= 6500) {
        this.percent = 2.05;
        this.profit = Math.floor(Deposit * this.percent);
      } else {
        return this.toastr.warningToastr(
          `$${Deposit} not avalable for this plan`,
        );
      }
    }

    // ELITE TIER
    if (this.options == 'elite-tier') {
      this.term = 30;

      if (Deposit >= 7800 && Deposit <= 13000) {
        this.percent = 2.35;
        this.profit = Math.floor(Deposit * this.percent);
      } else {
        return this.toastr.warningToastr(
          `$${Deposit} not avalable for this plan`,
        );
      }
    }

    // PLATINUM PACK
    if (this.options == 'platinum') {
      this.term = 30;

      if (Deposit >= 19500 && Deposit <= 500000) {
        this.percent = 2.8;
        this.profit = Math.floor(Deposit * this.percent);
      } else {
        return this.toastr.warningToastr(
          `$${Deposit} not avalable for this plan`,
        );
      }
    }



     if (this.options == 'btc-starter') {
        this.term = 1;
        if (Deposit >= 100 && Deposit <= 999) {
          this.profit = Math.floor(Deposit * 1.10);
          this.percent = 1.10;
        } else {
          return this.toastr.warningToastr(
            `$${Deposit} not avalable for this plan`
          );
        }
    }


     if (this.options == 'eth-growth') {
        this.term = 2;
        if (Deposit >= 1000 && Deposit <= 9999) {
          this.profit = Math.floor(Deposit * 1.15);
          this.percent = 1.15;
        } else {
          return this.toastr.warningToastr(
            `$${Deposit} not avalable for this plan`
          );
        }
    }


     if (this.options == 'xrp-stream') {
        this.term = 7;
        if (Deposit >= 10000) {
          this.profit = Math.floor(Deposit * 1.30);
          this.percent = 1.30;
        } else {
          return this.toastr.warningToastr(
            `$${Deposit} not avalable for this plan`
          );
        }
    }



    if (this.options == 'ark-estate') {
        this.term = 7;
        if (Deposit >= 10000) {
          this.profit = Math.floor(Deposit * 1.30);
          this.percent = 1.30;
        } else {
          return this.toastr.warningToastr(
            `$${Deposit} not avalable for this plan`
          );
        }
    }


    if (this.options == 'special') {
      this.term = this.duration;
      if (
        this.amount >= this.activate.snapshot.queryParamMap.get('amount') &&
        this.amount <= this.activate.snapshot.queryParamMap.get('amount')
      ) {
        this.profit = Math.floor(
          Deposit * Number(this.activate.snapshot.queryParamMap.get('per')),
        );
        this.percent = Number(this.activate.snapshot.queryParamMap.get('per'));
      } else {
        return this.toastr.warningToastr(
          `$${Deposit} not avalable for this plan`,
        );
      }
    }

    if (this.options == 'bullion') {
      this.term = 4;
      if (this.amount >= this.activate.snapshot.queryParamMap.get('amount')) {
        this.profit = Math.floor(
          Deposit * Number(this.activate.snapshot.queryParamMap.get('per')),
        );
        this.percent = Number(this.activate.snapshot.queryParamMap.get('per'));
      } else {
        return this.toastr.warningToastr(
          `$${Deposit} not avalable for this plan`,
        );
      }
    }

    if (this.options == 'fortis') {
      this.term = 4;
      if (this.amount >= this.activate.snapshot.queryParamMap.get('amount')) {
        this.profit = Math.floor(
          Deposit * Number(this.activate.snapshot.queryParamMap.get('per')),
        );
        this.percent = Number(this.activate.snapshot.queryParamMap.get('per'));
      } else {
        return this.toastr.warningToastr(
          `$${Deposit} not avalable for this plan`,
        );
      }
    }



    this.netprofit = this.profit - Deposit;
    this.ammethod = Deposit;
    this.plan = this.options;
    this.type = 'Invest';
    this.duration = this.term;
    this.paymethod = spendFrom;

    //this.money = 2;
    this.Deposit()
  }

  calc() {
    this.options = this.options;
    let Deposit = parseFloat(this.amount1);
    let spendFrom = this.spend;
    if (!this.amount1) {
      return this.toastr.warningToastr('Input amount');
    }

    if (this.options == 'Basic') {
      this.term = 1;
      if (Deposit >= 10000 && Deposit <= 25000) {
        this.profit = (Deposit * ((1.48 - 1) * this.duration + 1)).toFixed(2);
        this.percent = 1.48;
      } else {
        return this.toastr.warningToastr(
          `$${Deposit} not avalable for this plan`
        );
        // this.profit = (Deposit * ((1.48 - 1) * this.duration + 1)).toFixed(2);
        // this.percent = 1.48;
      }
    }

    if (this.options == 'Performer') {
      this.term = 1;
      if (Deposit >= 26000 && Deposit <= 50000) {
        this.profit = (Deposit * ((1.56 - 1) * this.duration + 1)).toFixed(2);
        this.percent = 1.56;
      } else {
        return this.toastr.warningToastr(
          `$${Deposit} not avalable for this plan`
        );
        // this.profit = (Deposit * ((1.56 - 1) * this.duration + 1)).toFixed(2);
        // this.percent = 1.56;
      }
    }

    if (this.options == 'Supreme') {
      this.term = 1;
      if (Deposit >= 51000 && Deposit <= 100000) {
        this.profit = (Deposit * ((1.62 - 1) * this.duration + 1)).toFixed(2);
        this.percent = 1.62;
      } else {
        return this.toastr.warningToastr(
          `$${Deposit} not avalable for this plan`
        );
        // this.profit = (Deposit * ((1.62 - 1) * this.duration + 1)).toFixed(2);
        // this.percent = 1.62;
      }
    }

    if (this.options == 'Turbo') {
      this.term = 1;
      if (Deposit >= 102000 && Deposit <= 5000000) {
        this.profit = (Deposit * ((1.8 - 1) * this.duration + 1)).toFixed(2);
        this.percent = 1.8;
      } else {
        return this.toastr.warningToastr(
          `$${Deposit} not avalable for this plan`
        );
        // this.profit = (Deposit * ((1.8 - 1) * this.duration + 1)).toFixed(2);
        // this.percent = 1.8;
      }
    }

    this.netprofit = this.profit - Deposit;
    this.ammethod = Deposit;
    this.plan = this.options;
    this.paymethod = spendFrom;
    this.type = 'Contract';
    this.pucg = 1;

    this.Deposit();
  }


 priceToGrams(price: number) {
  price = Number(price);


  const result = price / 130



  return Number(result.toFixed(2)); // final numeric value
}




checkEligibilty() {
   if (this.options == 'starter') {
      if (this.amount >= 39 && this.amount <= 260) {
        // this.money = 2
        return true;
      } else {
        return this.toastr.warningToastr(
          `$${this.amount} not avalable for this plan`,
        );
      }
    }

    if (this.options == 'prime') {
      if (this.amount >= 325 && this.amount <= 585) {
        // this.money = 2
        return true;
      } else {
        return this.toastr.warningToastr(
          `$${this.amount} not avalable for this plan`,
        );
      }
    }

    if (this.options == 'elite') {
      if (this.amount >= 650 && this.amount <= 1300) {
        // this.money = 2
        return true;
      } else {
        return this.toastr.warningToastr(
          `$${this.amount} not avalable for this plan`,
        );
      }
    }

    if (this.options == 'sovereign') {
      if (this.amount >= 1950 && this.amount <= 6500) {
        //this.money = 2
        return true;
      } else {
        return this.toastr.warningToastr(
          `$${this.amount} not avalable for this plan`,
        );
      }
    }

    if (this.options == 'aurum') {
      if (this.amount >= 7800 && this.amount <= 13000) {
        //  this.money = 2
        return true;
      } else {
        return this.toastr.warningToastr(
          `$${this.amount} not avalable for this plan`,
        );
      }
    }

    if (this.options == 'classic') {
      if (this.amount >= 130 && this.amount <= 1300) {
        // this.money = 2
        return true;
      } else {
        return this.toastr.warningToastr(
          `$${this.amount} not avalable for this plan`,
        );
      }
    }

    if (this.options == 'prestige') {
      if (this.amount >= 1950 && this.amount <= 6500) {
        // this.money = 2
        return true;
      } else {
        return this.toastr.warningToastr(
          `$${this.amount} not avalable for this plan`,
        );
      }
    }

    if (this.options == 'elite-tier') {
      if (this.amount >= 7800 && this.amount <= 13000) {
        //  this.money = 2
        return true;
      } else {
        return this.toastr.warningToastr(
          `$${this.amount} not avalable for this plan`,
        );
      }
    }

    if (this.options == 'platinum') {
      if (this.amount >= 19500 && this.amount <= 500000) {
        return true;
      } else {
        return this.toastr.warningToastr(
          `$${this.amount} not avalable for this plan`,
        );
      }
    }



     if (this.options == 'btc-starter') {

        if (this.amount >= 100 && this.amount <= 999) {
          return true;
        } else {
          return this.toastr.warningToastr(
            `$${this.amount} not avalable for this plan`
          );
        }
    }


     if (this.options == 'eth-growth') {

        if (this.amount >= 1000 && this.amount <= 9999) {
           return true;
        } else {
          return this.toastr.warningToastr(
            `$${this.amount} not avalable for this plan`
          );
        }
    }


     if (this.options == 'xrp-stream') {
        if (this.amount >= 10000) {
         return true;
        } else {
          return this.toastr.warningToastr(
            `$${this.amount} not avalable for this plan`
          );
        }
    }



    if (this.options == 'ark-estate') {
        if (this.amount >= 10000) {
         return true;
        } else {
          return this.toastr.warningToastr(
            `$${this.amount} not avalable for this plan`
          );
        }
    }

    const requiredAmountParam = this.activate.snapshot.queryParamMap.get('amount');
    const requiredAmount = requiredAmountParam ? Number(requiredAmountParam) : null;

    if(this.options == 'special') {
      if (requiredAmount === null || isNaN(requiredAmount)) {
        return this.toastr.warningToastr('Invalid required amount for this plan');
      }

      if(this.amount >= requiredAmount && this.amount <= requiredAmount) {
      //  this.money = 2
        return true;
      } else {
        return this.toastr.warningToastr(
          `$${this.amount} not avalable for this plan`
        );
      }
    }

    if(this.options == 'ownership') {
      if(this.amount >= 5000) {
      //  this.money = 2
        return true;
      } else {
        return this.toastr.warningToastr(
          ` you cant purchase $${this.amount} worth of physical gold`
        );
      }
    }

    if(this.options == 'bullion') {
      if (requiredAmount === null || isNaN(requiredAmount)) {
        return this.toastr.warningToastr('Invalid required amount for this plan');
      }

      if(this.amount >= requiredAmount) {
      //  this.money = 2
        return true;
      } else {
        return this.toastr.warningToastr(
          `$${this.amount} not avalable for this plan`
        );
      }
    }

    if(this.options == 'fortis') {
      if (requiredAmount === null || isNaN(requiredAmount)) {
        return this.toastr.warningToastr('Invalid required amount for this plan');
      }

      if(this.amount >= requiredAmount) {
      //  this.money = 2
        return true;
      } else {
        return this.toastr.warningToastr(
          `$${this.amount} not avalable for this plan`
        );
      }
    }

  return false;

}

  atLeastOneRadio() {
    if (this.options == null) {
      this.toastr.warningToastr('Select an investment scheme', 'security');
    } else {
      this.chackGram();
      return true;
    }
  }

chackGram() {
  if (!this.amount || !this.options) {
    this.gram = null;
    return;
  }

  const amount = Number(this.amount);

  switch (this.options) {
    case 'starter':
      this.gram = this.priceToGrams(amount);
      break;

    case 'prime':
      this.gram = this.priceToGrams(amount);
      break;

    case 'elite':
      this.gram = this.priceToGrams(amount);
      break;

    case 'sovereign':
      this.gram = this.priceToGrams(amount);
      break;

    case 'aurum':
      this.gram = this.priceToGrams(amount);
      break;

    case 'classic':
      this.gram = this.priceToGrams(amount);
      break;

    case 'prestige':
      this.gram = this.priceToGrams(amount);
      break;

    case 'elite-tier':
      this.gram = this.priceToGrams(amount);
      break;

    case 'platinum':
      this.gram = this.priceToGrams(amount);
      break;

    case 'ownership':
      this.gram = this.priceToGrams(amount);
      break;

    case 'bullion':
      this.gram = this.priceToGrams(amount);
      break;

    case 'fortis':
      this.gram = this.priceToGrams(amount);
      break;

    default:
      this.gram = Number(this.activate.snapshot.queryParamMap.get('gram'));
  }
}

  chek() {
    if (this.options == null || $('#custom-amount').val() == 0) {
      return false;
    } else {
      return true;
    }
  }

  Deposit() {

    console.log(this.paymethod, this.netprofit, this.ammethod, this.plan);
    if (
      this.paymethod == 'USDT(BEP20)' || this.paymethod == 'USDT(TRC20)' || this.paymethod == 'XRP' ||
      this.paymethod == 'UPI' &&
      (this.ammethod && this.plan)
    ) {
      let med = {
        user_id: this.Id,
        plan: this.plan,
        profit: this.profit,
        amount: this.ammethod,
        username: this.users,
        paymethod: this.paymethod,
        gram : this.gram,
        type: this.type,
        percent: this.percent,
        duration: this.duration ? this.duration : 1,
        key: 'depoBitcoin',
      };


      this.server.Api(med).subscribe((res: any) => {
        if (res['message']) {
          this.toastr.infoToastr(res['message'], 'security');
        }
        if (res['code'] == 1) {
          this.amountTopay = '$' + res['amount_btc'];
          this.addressTopay = res['address'];
          this.tic = res['tic'];
          if (this.tic == 'UPI') {
            this.amountTopay =  '₹' + res['amount_btc'] * 89;
            this.upU = res['address'];
            this.upID = res['upname'];
          }
          this.bank = 2;
        }
      });
    } else if (
      this.paymethod == 'Bank' &&
      this.ammethod &&
      this.plan
    ) {
      let med = {
        user_id: this.Id,
        plan: this.plan,
        profit: this.profit,
        amount: this.ammethod,
        username: this.users,
        type: 'Invest',
        paymethod: this.paymethod,
        gram: this.gram,
        percent: this.percent,
        duration: this.duration ? this.duration : 1,
        key: 'depoBank',
      };
      this.server.Api(med).subscribe(
        (res: any) => {
          if (res['message']) {
            this.toastr.infoToastr(res['message'], 'security');
          }
          if (res['code'] == 1) {
            this.banks = res['banks'];
            this.rand = res['payment'];
            this.amm = '₹' + res['amount'] * 89;
            // this.amm = Number(this.amm.toPrecision(2));
            this.bank = 1;
          }
        },
        () => {},
        () => {}
      );
    } else {
      if (
        this.paymethod == 'Account' &&
        this.ammethod &&
        this.plan
      ) {
        let payload = {
          plan: this.plan,
          username: this.users,
          profit: this.profit,
          amount: this.ammethod,
          paymethod: this.paymethod,
          gram: this.gram,
          val: this.Id,
          percent: this.percent,
          type: this.type,
          duration: this.duration ? this.duration : 1,
          key: 'depo',
        };

        this.server.Api(payload).subscribe((res: any) => {
          if (res['message']) {
            this.toastr.infoToastr(res['message'], 'security');
          }
          if (res['code'] == 1) {
            this.toastr.successToastr('Your Deposit is Accepted', '', {
              animate: 'fade',
            });
          }

          if (res['code'] == 2) {
            this.toastr.warningToastr(
              'You have insufficent funds in your wallet for this plan',
              '',
              { animate: 'fade' }
            );
          }

          if (res['code'] == 3) {
            this.toastr.errorToastr(
              'Deposit not accepted, you have an active deposite',
              '',
              { animate: 'fade' }
            );
          }
        });
      } else {
        this.toastr.errorToastr('Please select an amount', 'Security Center');
      }
    }
  }

  copy() {
    var copyText = $('#refUrl');
    copyText.select();
    document.execCommand('copy');
    this.toastr.successToastr('Link copied')
    let navigationExtras: NavigationExtras = {
      queryParams: {
        deposit: true,
      },
    };
    this.route.navigate(['/dashboard'], navigationExtras);
  }
}
